<template lang="pug">
v-dialog(v-model='isOpen' max-width='800px' persistent scrollable)
  v-card
    v-card-title
      span(class='headline') Квартира: {{btiPlan.apartment_ui}}
    v-card-text( class="pt-0")
      v-container(grid-list-xl fluid)
        v-layout(wrap align-center)
          v-flex(sm4 xs12)
            v-img(
              :aspect-ratio='1'
              :lazy-src='btiPlan.plan_image_url'
              :src='btiPlan.plan_image_url'
              class='grey lighten-4'
              contain
            )
          v-flex(sm4 xs12)
            s-image-upload(
                :ratio='1'
                :src='btiPlan.placement_sizing_url'
                v-model='btiPlan.placement_sizing'
                label='Линейные размеры'
              )
          v-flex(sm4 xs12)
            s-image-upload(
              :ratio='1'
              :src='btiPlan.render_view_url'
              v-model='btiPlan.render_view'
              label='Планировка с мебелью'
            )
    v-card-actions
      v-spacer
      v-btn(flat @click="$emit('undo')") Отмена
      v-btn(
        flat
        @click="updateBtiPlan"
        color="primary"
      ) Сохранить
</template>

<script>
import http from '@/http'

export default {
  props: ['btiPlan', 'isOpen'],
  data: () => ({
    
  }),
    methods: {

    async updateBtiPlan() {
      if (await this.$confirm('Обновить БТИ планировки?')) {
        try {
          await http.post(`/complexes/objects/btiplacements/${this.btiPlan.apartment_ui}/`, {
            render_view: this.btiPlan.render_view,
            placement_sizing: this.btiPlan.placement_sizing
          })
          this.$emit('onSave').$emit('undo')
        } catch (e) {
          this.$root.showSnack('Не удалось удалить менеджера из отдела')
        }
      }
    }
  }
}
</script>